<template>
	<transition name="show" @after-leave="afterLeave">
		<div v-show="show" class="wrapper">
			<div :class="['box', 'item', notification.type]">
				<p>{{ notification.message }}</p> <span class="material-icons close p-1" @click="close">close</span>
			</div>
		</div>
	</transition>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { NotificationItem } from "@/models/AppConfig";
import { ConfigMutations } from '@/store/modules/config/mutations';
import { STATE_MODULES } from '@/store/state-modules';

export default defineComponent({
	data () {
		return {
			show: false,
			closeTimeout: 0
		}
	},
	mounted () {
		this.show = true;
		this.closeTimeout = setTimeout(() => {
			this.close()
		}, this.$props.notification.duration || 500);
	},
	methods: {
		afterLeave () {
			this.$store.commit(`${STATE_MODULES.CONFIG}/${ConfigMutations.REMOVE_NOTIFICATION}`, this.$props.notification);
		},
		close () {
			clearTimeout(this.closeTimeout);
			this.show = false
		}
	},
	props: {
		notification: {
			type: Object as () => NotificationItem,
			required: true
		}
	}
})
</script>

<style scoped>
	.wrapper {
		max-width: 600px;
		margin: 0 auto;
		height: 70px;
		opacity: 1;
	}

	.item{
		color: #fff;
		position: relative;
	}

	.show-enter-active, .show-leave-active, .show-enter-to, .show-leave-from {
		transition: all 0.5s ease;
	}

	.show-enter-from, .show-leave-to {
		height: 0;
		opacity: 0;
		overflow: hidden;
	}

	.error{
		background: var(--bulma-danger);
	}

	.info{
		background: var(--bulma-info);
	}

	.success{
		background: var(--bulma-success);
	}

	.close {
		position: absolute;
		top: 0;
		right: 0;
		cursor: pointer;
	}

	p{
		text-overflow: ellipsis;
		white-space: nowrap;     /* Prevent text from wrapping to the next line */
		overflow: hidden; 
	}
</style>
